export default {
    _chew: 'chew',
    _click: 'click',
    _correct: 'correct',
    _crash: 'crash',
    _die: 'die',
    _effect1: 'effect1',
    _effect2: 'effect2',
    _hooray: 'hooray',
    _incorrect: 'incorrect',
    _music: 'music',
    _pop: 'pop',
    _swosh_in: 'swosh_in',
    _thump: 'thump',
    _whistle_down: 'whistle_down',
    _whistle_up: 'whistle_up',
}